import { getChatSession } from './getChatSession'
import { renderChat } from './renderChat'
import { saveChatMessageToSession } from './saveChatMessageToSession'

/**
 *
 * @param {import('@livechat/customer-sdk').CustomerSDK} instance
 * @param {1 | 0} rating
 */
export async function rateChat(instance, rating) {
  const session = getChatSession()
  await instance.rateChat({
    chatId: session.chatId,
    rating: {
      score: rating,
    },
  })

  const thumbsUp = document.getElementById('thumbs-up')
  const thumbsDown = document.getElementById('thumbs-down')
  if (!thumbsUp || !thumbsDown) {
    throw new Error('unexpected: rating thumbs missing')
  }

  let text = "We're sorry to hear that. We'll work to improve"
  if (rating === 1) {
    thumbsUp.style.fill = '#4CAF50'
    thumbsDown.style.fill = 'none'
    text = 'Thanks for your positive feedback'
  } else {
    thumbsDown.style.fill = '#F44336'
    thumbsUp.style.fill = 'none'
  }

  // To do use incomingEvent to renderChat
  saveChatMessageToSession({
    authorId: 'rating-system',
    authorType: 'system',
    id: 'system-rating-message',
    text,
    timestamp: Date.now(),
  })
  renderChat()
}
